import { render, staticRenderFns } from "./InserimentoDati.vue?vue&type=template&id=5e165c4c&scoped=true&"
import script from "./InserimentoDati.vue?vue&type=script&lang=js&"
export * from "./InserimentoDati.vue?vue&type=script&lang=js&"
import style0 from "./InserimentoDati.vue?vue&type=style&index=0&id=5e165c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e165c4c",
  null
  
)

export default component.exports